export const OPTIMIZELY_MATCH_TYPES = {
  simple: 'simple',
  exact: 'exact',
  substring: 'substring',
  regex: 'regex'
}

export const OPTIMIZELY_EXPERIMENTS = {
  vaultFakedoortest: 'vault_email_forwarding_tiles',
  healthQuickQuoteVariant: 'health_quick_quote_variant'
}

export const OPTIMIZELY_VARIATIONS = {
  control: 'control',
  variant: 'variant'
}
